import { render, staticRenderFns } from "./expressDeliveryDelete.vue?vue&type=template&id=125943e6&scoped=true&"
import script from "./expressDeliveryDelete.vue?vue&type=script&lang=js&"
export * from "./expressDeliveryDelete.vue?vue&type=script&lang=js&"
import style0 from "./expressDeliveryDelete.vue?vue&type=style&index=0&id=125943e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125943e6",
  null
  
)

export default component.exports